import React from "react";
import { Container, Box, useMediaQuery, useTheme } from "@mui/material";
import ResponsiveAppBar from "./Appbar";
import Footer from "./Footer";

const Layout = ({ children }) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md")); // デスクトップ判定

  return (
    <Box
      className="App"
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh", // 画面全体の高さを確保
      }}
    >
      <ResponsiveAppBar />

      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          justifyContent: "center",
          py: 4,
          px: isDesktop ? 2 : 0, // デスクトップならパディングを追加
        }}
      >
        {/* 広告エリア（左） */}
        {isDesktop && (
          <Box
            sx={{
              width: "160px",
              mx: 2,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              bgcolor: "#f1f1f1",
              borderRadius: 2,
              boxShadow: 1,
            }}
          >
            <p>広告エリア (左)</p>
            {/* Googleアドセンスコードをここに挿入 */}
          </Box>
        )}

        {/* メインコンテンツ */}
        <Container component="main" maxWidth="lg" sx={{ flexGrow: 1 }}>
          {children}
        </Container>

        {/* 広告エリア（右） */}
        {isDesktop && (
          <Box
            sx={{
              width: "160px",
              mx: 2,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              bgcolor: "#f1f1f1",
              borderRadius: 2,
              boxShadow: 1,
            }}
          >
            <p>広告エリア (右)</p>
            {/* Googleアドセンスコードをここに挿入 */}
          </Box>
        )}
      </Box>

      <Footer />
    </Box>
  );
};

export default Layout;
